<template>
    <div>
        <h5 class="font-weight-bold">Card Readers</h5>
        <b-table-simple striped v-if="items.length">
            <b-thead head-variant="">
                <b-tr class="bg-gray-300">
                    <b-th>Card Reader Name</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item, index) in items" :key="index">
                    <b-th>
                        {{item.POSName}}
                    </b-th>
                    <b-th class="text-right">
                        <edit-card-reader :IKey="item.IKey" :restaurantId="restaurantId" @update="update"/>
                    </b-th>
                </b-tr>
            </b-tbody>
        </b-table-simple>
        <b-btn variant="danger" @click="addModal = true">
            Add Card Reader
            <font-awesome-icon icon="plus" class="align-middle mx-1"/>
        </b-btn>

        <c-modal v-model="addModal" title="Add Card Reader" :tag="false" :size="'lg'" centered>
            <template>
                <div class="h6 mb-0">
                    Swipe from left to right on the reader screen to
see Setting button and enter admin PIN 07139
to access Admin Options menu. Select
"Generate pairing code" to get a new
Registration Code and enter it below.                </div>
                <div class="h6 mb-3 mt-2">
                    Note: MENUPOLY only supports Strip card reader at this point.
                </div>
                <b-alert :show="errors.any()" variant="danger" class="px-4">
                    <ul class="m-0 px-1">
                        <li v-for="err in errors.all()" :key="err">{{err}}</li>
                    </ul>
                </b-alert>
                <div class="mb-3">
                    <b-input-group prepend="Reader Name">
                        <b-input class="myFeild" type="text" v-model="model.POSName" v-validate="'required'" name="Reader Name" placeholder="Required"/>
                    </b-input-group>
                </div>
                <div>
                    <b-input-group prepend="Registration Code">
                        <b-input class="myFeild" type="text" v-model="model.POSCode" v-validate="'required'" name="Registration Code" placeholder="Required"/>
                    </b-input-group>
                </div>
            </template>
            <template #actions>
                <b-row class="flex-grow-1">
                    <b-col cols="6">
                        <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="registerPOS">
                            Register Reader
                            <font-awesome-icon v-if="loading" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                        </b-btn>
                    </b-col>

                    <b-col cols="6">
                        <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="addModal = false">
                            Cancel
                        </b-btn>
                    </b-col>
                </b-row>
            </template>
        </c-modal>
    </div>
</template>

<script>
    import EditCardReader from "./editCardReader";
    import CModal from "./Cmodal";
    export default {
        name: "cardReader",
        components: {CModal, EditCardReader},
        props: {
            items: {required: true},
            restaurantId: {required: true},
        },
        data () {
            return {
                addModal: false,
                loading: false,
                model: {
                    POSName: null,
                    POSCode: null
                }
            }
        },
        methods: {
            registerPOS () {
                this.$validator.validateAll().then(proceed => {
                    if (proceed) {
                        const model = {...this.model}
                        model.RestaurantID = this.restaurantId
                        model.UserID = localStorage.getItem('userID')
                        this.loading = true
                        this.$api.getRestaurant.RegisterPOS(model).then(res => {
                            this.loading = false
                            if (res.success) {
                                this.addModal = false
                                this.$emit('updateCardReaders')
                            } else {
                                this.$showError(res.message)
                            }
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                })
            },
            update () {
                this.$emit('updateCardReaders')
            }
        }
    }
</script>

<style scoped>

</style>
